import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { EditIcon, Delete02Icon, PlusIcon } from '../../../../../assets/icons';
import WorkRegionModal from '../../../../../components/modals/UserProfile/WorkRegionModal';
import DeletePopup from '../../../../../components/delete-popup';
import { addUserWorkRegion, updateUserWorkRegion, deleteUserWorkRegion } from '../../../../../redux/slice/allUsersSlice';
import { useToast } from '../../../../../context/TostContext';
import { IconBtn } from '../../../../../components/commonButton/btns';

const WorkRegions = ({ userDetail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const workRegions = userDetail?.work_regions || [];

    const handleUpsertWorkRegion = (data) => {
        setIsLoading(true);
        const action = currentItem
            ? updateUserWorkRegion({ id: id, regionId: currentItem.id, data })
            : addUserWorkRegion({ id: id, data });

        dispatch(action)
            .unwrap()
            .then(() => {
                toast.success(`Work region ${currentItem ? "updated" : "added"} successfully`);
                setShowModal(false);
                setCurrentItem(null);
            })
            .catch((error) => {
                toast.error(error?.message || `Failed to ${currentItem ? "update" : "add"} work region`);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleDeleteWorkRegion = () => {
        setIsLoading(true);
        dispatch(deleteUserWorkRegion({ id: id, regionId: itemToDelete }))
            .unwrap()
            .then(() => {
                toast.success("Work region deleted successfully");
                setShowDeletePopup(false);
                setItemToDelete(null);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete work region");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="position-relative h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h6 className="fw-bold mb-0" style={{ fontSize: '18px' }}>Work Regions</h6>
                <IconBtn size={32} icon={<PlusIcon size={16} />} className='rounded-circle' onClick={() => {
                    setCurrentItem(null);
                    setShowModal(true);
                }} />

            </div>


            {workRegions.length > 0 ? (
                <div className="bg-white rounded-3 overflow-hidden shadow-sm p-4">
                    <div className="d-flex flex-wrap gap-2">
                        {workRegions.map((region, index) => (
                            <span
                                key={region.id || index}
                                className="badge bg-light text-dark border px-3 py-2 rounded-pill fs-6 fw-normal shadow-sm d-flex align-items-center gap-2"
                            >
                                {region.title}
                                <div className="d-flex align-items-center gap-1 border-start ps-2 ms-1">
                                    <button
                                        className="bg-transparent border-0 p-0 p-0 text-primary"
                                        onClick={() => {
                                            setCurrentItem(region);
                                            setShowModal(true);
                                        }}
                                        title="Edit"
                                    >
                                        <EditIcon width={12} height={12} />
                                    </button>
                                    <button
                                        className="bg-transparent border-0 p-0 text-danger"
                                        onClick={() => {
                                            setItemToDelete(region.id);
                                            setShowDeletePopup(true);
                                        }}
                                        title="Delete"
                                    >
                                        <Delete02Icon size={12} />
                                    </button>
                                </div>
                            </span>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="text-center py-5 text-muted">
                    <p className="mb-0">No work regions listed.</p>
                </div>
            )}
            <WorkRegionModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onSubmit={handleUpsertWorkRegion}
                region={currentItem}
                isLoading={isLoading}
                title={currentItem ? "Edit Work Region" : "Add Work Region"}
                size="md"
            />

            {showDeletePopup && (
                <DeletePopup
                    show={showDeletePopup}
                    onHide={() => setShowDeletePopup(false)}
                    onConfirm={handleDeleteWorkRegion}
                    disabled={isLoading}
                    title="Delete Work Region"
                    content="Are you sure you want to delete this work region?"
                    saveTitle="Delete"
                />
            )}
        </div>
    );
};

export default WorkRegions;
